import { IconPencil } from "@tabler/icons-react";
import { Card, CardProps } from "../Card";

export function Button({ children, variant, ...props }: CardProps) {
  return (
    <Card variant={variant ?? "regular"} act="button" {...props}>
      <Card.Content padding="sm" preset="flex-aligned-center">
        {children}
      </Card.Content>
    </Card>
  );
}
